export interface FilteredOrganizationModel {
  code: string;
  name: string;
  id: 0;
}
